<div class="p-4 space-y-4">
  @if (isLoading()) {
    <div class="flex items-center justify-center py-8">
      <svg
        class="w-6 h-6 animate-spin text-gray-600"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
      </svg>
      <span class="ml-2 text-sm text-gray-600">{{ 'propertyFormat.loading' | translate }}</span>
    </div>
  } @else {
    <div>
      <label for="contentControlTitle" class="block text-sm font-medium text-gray-700 mb-2">
        {{ 'propertyFormat.contentControlTitle' | translate }}
      </label>
      <input
        id="contentControlTitle"
        type="text"
        [value]="titleSignal()"
        (input)="onTitleChange($event)"
        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-main focus:border-transparent text-base text-gray-900" />
    </div>
    <div>
      <label for="contentControlTag" class="block text-sm font-medium text-gray-700 mb-2">
        {{ 'propertyFormat.contentControlTag' | translate }}
      </label>
      <input
        id="contentControlTag"
        type="text"
        [value]="tagSignal()"
        (input)="onTagChange($event)"
        class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-main focus:border-transparent text-base text-gray-900" />
    </div>
    <div>
      <button
        type="button"
        (click)="onSaveTitleAndTag()"
        [disabled]="isSaving()"
        [class]="
          'px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-main focus:ring-offset-2 flex items-center justify-center gap-2 ' +
          (!isSaving()
            ? 'border-main text-main border hover:text-white hover:bg-main/90'
            : 'bg-gray-300 text-gray-500 cursor-not-allowed')
        ">
        @if (isSaving()) {
          <svg
            class="w-4 h-4 animate-spin text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24">
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4" />
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          <span>{{ 'propertyFormat.saving' | translate }}</span>
        } @else {
          <span>{{ 'propertyFormat.save' | translate }}</span>
        }
      </button>
    </div>
  }
</div>
